import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { HISTORY_EVENT_PARAM } from '../constants/history.js';
import { DRIVE_FOLDER_PARAM, DRIVE_ROOT_ID } from '../constants/knowledge.js';
import { TAB_KINDS } from '../constants/profileTabs.js';
import { useTabPath } from './useTabPath.js';

/**
 * A Sandbox group's "Open" (CT-5718): where the claims came from — the file in
 * Drive (in its folder), or the event in the History tab.
 */
export function useOpenSandboxSource({ tabs = [], openTab } = {}) {
  const navigate = useNavigate();
  const tabPath = useTabPath();
  const historyTab = useMemo(() => tabs.find((tab) => tab.kind === TAB_KINDS.ACTIVITY), [tabs]);

  return useCallback(
    (group) => {
      const ref = group?.sourceRef;
      if (ref?.kind === 'file') {
        const inFolder = ref.folderId && ref.folderId !== DRIVE_ROOT_ID;
        navigate(`${tabPath}/drive${inFolder ? `?${DRIVE_FOLDER_PARAM}=${encodeURIComponent(ref.folderId)}` : ''}`);
      } else if (ref?.kind === 'event' && historyTab) {
        openTab?.(historyTab.id, `?${HISTORY_EVENT_PARAM}=${encodeURIComponent(ref.id)}`);
      }
    },
    [navigate, tabPath, historyTab, openTab],
  );
}

export default useOpenSandboxSource;
